import React from 'react'
// @src imports
import {
  useAccount,
  useActions,
  useLoading,
  useMeasurements,
  useMutations,
  useState,
} from 'src/hooks'
import { PurchaseTypes } from 'src/payments/containers/Payment'
import { Transition } from 'src/chrome'
import Payment, { ExpenseReload } from 'src/plans/components/Payment'
import { PlansSlider } from 'src/marketing/plans/components'
import { enabledPlans } from 'src/marketing/plans/plansInfo'
import { PlanFragment } from 'src/graphql'
import { AddOn } from '../../marketing/plans/types'

type Props = {
  currentPlan: string
  initialPlanName: string
  onAfterPurchase: () => void
  onCancel: () => void
}

const styles = {
  paymentContainer: {
    padding: '10px 0 20px',
    '@media (max-width: 650px)': {
      paddingBottom: '100px',
    },
  },
}

const PlanBuyer: React.FC<Props> = props => {
  const { initialPlanName, onAfterPurchase, onCancel } = props

  const account = useAccount()
  const actions = useActions()
  const mutations = useMutations()
  const { windowWidth } = useMeasurements()
  const [planName, setPlanName] = useState(initialPlanName)
  const purchasing = useLoading()

  const isMediumScreen = windowWidth <= 1060

  const filteredPlans = enabledPlans.filter(
    p => p.title !== 'Basic' && p.title !== 'Legacy',
  )

  const tabs = filteredPlans.map(p => p.title)

  const index = tabs.indexOf(planName)

  const changePlan = (planName: string) => {
    setPlanName(planName)
  }

  const purchase = async (
    planName: string,
    expenseReload: ExpenseReload | undefined,
  ) => {
    const plan = enabledPlans.find(x => x.title === planName)
    if (!plan) {
      throw new Error(`plan ${planName} not found`)
    }

    const account = {
      plan: plan.id,

      ...(expenseReload
        ? {
            ...expenseReload,
            threshold: expenseReload.threshold / 100,
            isEnabled: true,
          }
        : {}),
    }

    purchasing.start()

    try {
      const {
        updateAccount: { account: updatedAccount },
      } = await mutations.updateAccount({ account })
      actions.updatedAccount(updatedAccount)
      onAfterPurchase()
      purchasing.end()
    } catch (error) {
      console.error(error)
      purchasing.end()
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <PlansSlider
          plans={filteredPlans}
          tabs={tabs}
          currentIndex={index}
          onRightArrowClick={() => changePlan(tabs[index + 1])}
          onLeftArrowClick={() => changePlan(tabs[index - 1])}
          onTabClick={changePlan}
          shouldSkipPlansSliderAnimation={false}
          isMediumScreen={isMediumScreen}
        />
      </div>

      {purchasing.isLoading && (
        <Transition
          message={'Purchasing plan...'}
          subMessage={undefined}
          style={{
            position: 'absolute',
            height: '100%',
          }}
        />
      )}
      <div css={styles.paymentContainer}>
        <Payment
          account={account}
          onCancel={onCancel}
          onPurchase={expenseReload => purchase(planName, expenseReload)}
          paymentInfo={{
            purchaseType: PurchaseTypes.PLAN,
            items: [
              enabledPlans.find(x => x.title === planName),
              undefined,
            ].filter(Boolean) as Array<AddOn | PlanFragment>,
          }}
        />
      </div>
    </>
  )
}

export default PlanBuyer
